import { links } from "data/constants";

const platforms = [
  {
    name: "windows",
    packageType: "exe",
    icon: `${links.imagesBaseUrl}/icons2/Icon_windows.svg`,
    label: "Windows",
    description: "Windows 10 or later",
    withBadge: true,
  },
  {
    name: "windows",
    packageType: "msi",
    icon: `${links.imagesBaseUrl}/icons2/Icon_windows.svg`,
    label: "Windows",
    description: "Windows 10 or later",
    withBadge: true,
  },
  {
    name: "macos",
    packageType: "pkg",
    icon: `${links.imagesBaseUrl}/icons2/Icon_apple.svg`,
    label: "Mac",
    description: "macOS 13 or later",
  },
  {
    name: "linux",
    packageType: "deb",
    icon: `${links.imagesBaseUrl}/icons2/Icon_ubuntu.svg`,
    label: "Ubuntu",
    description: "Ubuntu 20.04 or later",
    withInstructions: true,
  },
  {
    name: "linux",
    packageType: "rpmRedHat",
    icon: `${links.imagesBaseUrl}/icons2/Icon_redHat.svg`,
    label: "Red Hat",
    description: "Red Hat 8 or later",
    withInstructions: true,
  },
  {
    name: "linux",
    packageType: "rpmFedora",
    icon: `${links.imagesBaseUrl}/icons2/icon_fedora.svg`,
    label: "Fedora",
    description: "Fedora 40 or later",
    withInstructions: true,
  },
  {
    name: "linux",
    packageType: "generic",
    icon: `${links.imagesBaseUrl}/icons2/icon_linux.svg`,
    label: "Linux - Other",
    description: "Linux 8 or later",
    withInstructions: true,
  },
  {
    name: "android",
    packageType: "",
    icon: `${links.imagesBaseUrl}/icons2/Icon_android.svg`,
    label: "Android / Chromebook",
    description: "Android 12.1 or later",
    link:
      "https://play.google.com/store/apps/details?id=com.perimeter81.android",
  },
  {
    name: "ios",
    packageType: "",
    icon: `${links.imagesBaseUrl}/icons2/Icon_apple.svg`,
    label: "iOS",
    description: "iOS 15 or later",
    link:
      "https://itunes.apple.com/us/app/safervpn-for-business/id1307953381?mt=8",
  },
  {
    name: "ios",
    packageType: "With Mobile Protect",
    icon: `${links.imagesBaseUrl}/icons2/Icon_apple.svg`,
    label: "iOS",
    description: "iOS 15 or later",
    additionalInfo: "Additional license is required",
    withBadge: true,
    link: "https://apps.apple.com/us/app/harmony-mobile-protect/id1006390797",
  },
];

export default platforms;
